import { SelectUser } from "../../../Users/shared/SelectUser.js";
import { SelectLocation } from "../../../Locations/shared/SelectLocation.js";
import { SelectEvent } from "../../../Events/shared/SelectEvent.js";
import { SelectReport } from "../../../Reports/shared/SelectReport.js";
import { SelectRecord } from "../../../Records/shared/SelectRecord.js";
import { SelectLocationLogEntry } from "../../../Locations/shared/LocationLogEntries/SelectLocationLogEntry.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/shared/RefLinkForm/components/SelectRefLinkValueForType.tsx
function SelectRefLinkValueForType({ bypassLocationLogLocationSelect, combineSelected, multi, onChangeValue, type, value }) {
	switch (type) {
		case "event": return /* @__PURE__ */ jsx(SelectEvent, {
			combineSelected,
			isClearable: true,
			multi,
			onChangeValue,
			value
		});
		case "report": return /* @__PURE__ */ jsx(SelectReport, {
			combineSelected,
			isClearable: true,
			multi,
			onChangeValue,
			value
		});
		case "user": return /* @__PURE__ */ jsx(SelectUser, {
			combineSelected,
			isClearable: true,
			multi,
			onChangeValue,
			value
		});
		case "location": return /* @__PURE__ */ jsx(SelectLocation, {
			combineSelected,
			isClearable: true,
			multi,
			onChangeValue,
			value
		});
		case "location-log-entry": return /* @__PURE__ */ jsx(SelectLocationLogEntry, {
			bypassLocationSelect: bypassLocationLogLocationSelect,
			combineSelected,
			isClearable: true,
			locationId: "",
			multi,
			onChangeValue,
			value
		});
		case "record": return /* @__PURE__ */ jsx(SelectRecord, {
			combineSelected,
			isClearable: true,
			multi,
			onChangeValue,
			value
		});
		default: return null;
	}
}
//#endregion
export { SelectRefLinkValueForType };

//# sourceMappingURL=SelectRefLinkValueForType.js.map